import { faTimes } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { isEmpty, toLower } from "lodash";
import React, { useState, useEffect } from "react";
import { Button, Image, Form, InputGroup } from "react-bootstrap";
import { FormControl, LoaderWrapper } from "../";
import { useDeepEffect } from "../../abstracts";
import AddToolTip from "../AddToolTip";
import FormControlSearch from "../FormControlSearch";
import { Link } from "../";

const MultiSelectDropdown = ({
  label,
  options,
  value,
  name,
  disabled,
  onSelect,
  isLoading,
  height,
  width,
  trigger,
  maxHeight,
  zIndex,
  background,
  overflow,
  position,
  isTypeAhead = false,
  isClear,
  placeholder,
  hideSelectedOptions,
  setToggle,
  isAllSelecetedByDefault,
  isArrayOfObjects = false,
  objectKey = null,
  onOptionClick = null,
  isSelectAllClick = null,
  showSelectAll = true,
}) => {
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [queriedValue, setQueriedValue] = useState("");
  const [transformedValues, setTransformedValues] = useState([]);
  const totalSelected = selectedOptions.length;
  console.log(options);
  const isAllSelected = queriedValue
    ? totalSelected >=
      options.filter((item) => toLower(item.label).includes(queriedValue))
        .length
    : totalSelected === options.length;

  useEffect(() => {
    const selectedOptionsOnMount = [];
    setTransformedValues(
      isArrayOfObjects
        ? options.map((item) => {
            if (value && value.some((e) => e[objectKey] == item.value)) {
              selectedOptionsOnMount.push(item);
            }
            return {
              ...item,
              checked: value && value.some((e) => e[objectKey] == item.value),
            };
          })
        : options.map((item) => {
            if ((value || []).includes(item.value)) {
              selectedOptionsOnMount.push(item);
            }
            return {
              ...item,
              checked: (value || []).includes(item.value),
            };
          })
    );
    setSelectedOptions(selectedOptionsOnMount);

    if (isAllSelecetedByDefault) {
      onSelectAllClick();
      setToggle(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useDeepEffect(() => {
    const selectedOptionsOnMount = [];
    setTransformedValues(
      isArrayOfObjects
        ? options.map((item) => {
            if (value && value.some((e) => e[objectKey] == item.value)) {
              selectedOptionsOnMount.push(item);
            }
            return {
              ...item,
              checked: value && value.some((e) => e[objectKey] == item.value),
            };
          })
        : options.map((item) => {
            if ((value || []).includes(item.value)) {
              selectedOptionsOnMount.push(item);
            }
            return {
              ...item,
              checked: (value || []).includes(item.value),
            };
          })
    );
    setSelectedOptions(selectedOptionsOnMount);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trigger]);

  const onValueChange = (selectedItem) => {
    const totalChecked = [];
    setTransformedValues(
      transformedValues.map((item) => {
        const checked =
          selectedItem.value === item.value ? !item.checked : item.checked;
        if (checked) {
          totalChecked.push(item);
        }
        return {
          ...item,
          checked,
        };
      })
    );
    onSelect(totalChecked.map(({ value }) => value));
    setSelectedOptions(totalChecked);
  };
  const clearChecked = () => {
    setTransformedValues(
      transformedValues.map((item) => ({
        ...item,
        checked: false,
      }))
    );
    //const checkedOptions = isAllSelected ? options : [];
    const checkedOptions = [];
    setSelectedOptions(checkedOptions);
    onSelect(checkedOptions.map(({ value }) => value));
  };
  console.log("trans", transformedValues);

  const onSelectAllClick = () => {
    const tran = queriedValue
      ? options.filter((item) => toLower(item.label).includes(queriedValue))
      : options;
    setTransformedValues(
      tran.map((item) => ({
        ...item,
        checked: isAllSelected ? false : true,
      }))
    );
    const allSelectedOptions = isAllSelected
      ? []
      : queriedValue
      ? options.filter((item) => toLower(item.label).includes(queriedValue))
      : options;
    setSelectedOptions(allSelectedOptions);
    isArrayOfObjects && isSelectAllClick(allSelectedOptions);
    onSelect(allSelectedOptions.map(({ value }) => value));
  };

  const rowItemFocus = (e, isFocus) => {
    const targetElement = e.target.parentElement;
    if (targetElement) {
      const classNames = targetElement.getAttribute("class");
      if (isFocus) {
        targetElement.setAttribute("class", `${classNames} focus`);
      } else {
        targetElement.setAttribute("class", classNames.replace(" focus", ""));
      }
    }
  };

  const optionsItem = [];
  transformedValues.forEach((item) => {
    if (!queriedValue || toLower(item.label).includes(queriedValue)) {
      if (disabled) {
        if (item.checked) {
          optionsItem.push(
            <div>
              <input
                custom
                className="m-1 checkbox-report"
                name={name}
                disabled={disabled}
                type="checkbox"
                label={
                  item.label.length > 25 && overflow ? (
                    <AddToolTip name={item.label}>
                      {item.label.slice(0, 25)}...
                    </AddToolTip>
                  ) : (
                    item.label
                  )
                }
                value={
                  item.label.length > 25 && overflow ? (
                    <AddToolTip name={item.label}>
                      {item.label.slice(0, 25)}...
                    </AddToolTip>
                  ) : (
                    item.label
                  )
                }
                checked={item.checked}
                id={`custom-radio-${name}-${item.value}`}
                key={`custom-radio-${name}-${item.value}`}
              />
              {item.label}
            </div>
          );
        }
      } else {
        optionsItem.push(
          <div className="additional-rule-alignment">
            <input
              custom
              className="m-1 checkbox-report"
              name={name}
              disabled={disabled}
              type="checkbox"
              onClick={() => {
                isArrayOfObjects && onOptionClick(item, item.checked);
              }}
              label={
                item.label && item.label.length > 25 && overflow ? (
                  <AddToolTip name={item.label}>
                    {item.label.slice(0, 25)}...
                  </AddToolTip>
                ) : (
                  item.label
                )
              }
              value={
                item.label && item.label.length > 25 && overflow ? (
                  <AddToolTip name={item.label}>
                    {item.label.slice(0, 25)}...
                  </AddToolTip>
                ) : (
                  item.label
                )
              }
              checked={item.checked}
              onFocus={(e) => rowItemFocus(e, true)}
              onBlur={(e) => rowItemFocus(e, false)}
              id={`custom-radio-${name}-${item.value}`}
              key={`custom-radio-${name}-${item.value}`}
              onChange={() => onValueChange(item)}
            />
            {item.label}
          </div>
        );
      }
    }
  });
  console.log("queriedValue", transformedValues, isAllSelected);
  const changeHandler = (e) => {
    setQueriedValue(toLower(e.target.value));
    if (isEmpty(e.target.value)) {
      setTransformedValues(
        options.map((item) => ({
          ...item,
          checked:
            transformedValues?.find((_) => _.value === item.value)?.checked ??
            false,
        }))
      );
    }
  };
  const className = disabled ? " disabled" : "";
  return (
    <div
      className={`multiselect-dropdown-wrapper ${className}`}
      style={{ height, width, maxHeight, zIndex, background, position }}
    >
      <LoaderWrapper isLoading={isLoading}>
        <div className="w-100 h-100 dropdown-items">
          <FormControl label={label}>
            {isTypeAhead && (
              <div className="search-wrapper">
                <InputGroup>
                  <InputGroup.Prepend>
                    <InputGroup.Text className="company-search-button">
                      <Image src="/assets/icons/svg/search.svg" />
                    </InputGroup.Text>
                  </InputGroup.Prepend>
                  <FormControlSearch
                    placeholder={placeholder}
                    autoFocus
                    type="text"
                    size="xs"
                    onChange={changeHandler}
                  />
                </InputGroup>
              </div>
            )}
            {/* <div className="button-wrapper">
              {!disabled && (
                <span className="total-selected">
                  {totalSelected > 0 && `(${totalSelected} selected) `}
                </span>
              )}
              {!disabled && (
                <Button
                  className="select-all-btn"
                  variant="link"
                  type="button"
                  onClick={onSelectAllClick}
                >
                  {!isAllSelected ? "Select All" : "Unselect All"}
                </Button>
              )}
            </div> */}
          </FormControl>
          {!hideSelectedOptions && selectedOptions.length > 0 && (
            <div className="selected-options">
              {selectedOptions.map((item) => {
                return (
                  <div
                    key={`${name}-${item.value}`}
                    className="selected-options-item"
                  >
                    <div className="d-flex w-100">
                      <div>{item.label}</div>
                      <Button
                        onClick={() => onValueChange(item)}
                        variant="link"
                      >
                        <FontAwesomeIcon icon={faTimes} />
                      </Button>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
          {showSelectAll && optionsItem.length != 0 && (
            <div
              className="d-flex flex-row space-between options "
              style={{
                paddingLeft: 24,
                paddingRight: 16,
                paddingBottom: 4,
                paddingTop: 4,
              }}
            >
              <div>
                <input
                  custom
                  className="m-2 checkbox-report"
                  name={name}
                  disabled={disabled}
                  type="checkbox"
                  value={!isAllSelected ? "Select all" : "Unselect Allsss"}
                  checked={isAllSelected}
                  id={`custom-radio-${name}-selectall`}
                  key={`custom-radio-${name}-selectall`}
                  onFocus={(e) => rowItemFocus(e, true)}
                  onBlur={(e) => rowItemFocus(e, false)}
                  onChange={onSelectAllClick}
                />
                {!isAllSelected ? "Select all" : "Unselect All"}
              </div>
              {isClear && (
                <div>
                  <Link onClick={() => clearChecked()}>Clear</Link>
                </div>
              )}
            </div>
          )}
          {optionsItem}
          {optionsItem.length === 0 && (
            <div
              style={{
                paddingLeft: "110px",
                paddingTop: "25px",
              }}
            >
              No data found
            </div>
          )}
        </div>
      </LoaderWrapper>
    </div>
  );
};

MultiSelectDropdown.defaultProps = {
  options: [],
  value: [],
  hideSelectedOptions: true,
};
export default MultiSelectDropdown;
